module.exports = __webpack_public_path__ + "static/media/VideoTutorialNotFocused.407c1a08.svg";